import React, {Component} from 'react';

import logo from '../../../assets/img/logo1.png';
import {Link} from 'react-router-dom';
import {deleteCookie} from '../../../server/util';

class parentHeader extends Component {
    signOut(){
        deleteCookie('parent');
        sessionStorage.clear();
    }
    render() {
        return (
            <header id="pageTop" className="header-wrapper">
                <div className="container-fluid color-bar top-fixed clearfix">
                    <div className="row">
                        <div className="col-sm-1 col-xs-2 bg-color-1">fix bar</div>
                        <div className="col-sm-1 col-xs-2 bg-color-2">fix bar</div>
                        <div className="col-sm-1 col-xs-2 bg-color-3">fix bar</div>
                        <div className="col-sm-1 col-xs-2 bg-color-4">fix bar</div>
                        <div className="col-sm-1 col-xs-2 bg-color-5">fix bar</div>
                        <div className="col-sm-1 col-xs-2 bg-color-6">fix bar</div>
                        <div className="col-sm-1 bg-color-1 hidden-xs">fix bar</div>
                        <div className="col-sm-1 bg-color-2 hidden-xs">fix bar</div>
                        <div className="col-sm-1 bg-color-3 hidden-xs">fix bar</div>
                        <div className="col-sm-1 bg-color-4 hidden-xs">fix bar</div>
                        <div className="col-sm-1 bg-color-5 hidden-xs">fix bar</div>
                        <div className="col-sm-1 bg-color-6 hidden-xs">fix bar</div>
                    </div>
                </div>
                <nav id="menuBar" className="navbar navbar-default lightHeader">
                    <div className="container">
                        <div className="navbar-header">
                            <button type="button" className="navbar-toggle" data-toggle="collapse"
                                    data-target="#navbar">
                                <span className="icon-bar"/>
                                <span className="icon-bar"/>
                                <span className="icon-bar"/>
                            </button>
                            <a href="https://www.mealmanage.com" className="navbar-brand" id="brand">
                                <img className="parent-logo" src={logo} alt=""/>
                            </a>
                        </div>
                        <div className="navbar-collapse collapse" id="navbar">
                            <ul className="nav navbar-nav navbar-right" style={{height: 'auto'}}>
                                <li className=" dropdown theme_red_color active">
                                    <a href="javascript:void(0)" role="button" aria-haspopup="true"
                                          aria-expanded="false" onClick={()=>{
                                            window.location.href='/parent';
                                        }}><i
                                        className="fa fa-home theme_red_bg_color" aria-hidden="true"  />
                                        <span>Home</span></a>
                                </li>
                                <li className=" dropdown color-8 active">
                                    <Link to="/parent/notifications" role="button" aria-haspopup="true"
                                          aria-expanded="false"><i
                                        className="fa fa-bell bg-color-8" aria-hidden="true"/>
                                        <span>Notifications</span></Link>

                                </li>  
                                <li className=" dropdown color-8 active">
                                    <Link to="/parent/support" role="button" aria-haspopup="true"
                                          aria-expanded="false"><i
                                        className="fa fa-question bg-color-2" aria-hidden="true"/>
                                        <span>Support</span></Link>
                                </li> 
                             {/*  <li className=" dropdown color-8 active">
                                    <Link to="/parent/Studentregistration" role="button" aria-haspopup="true"
                                          aria-expanded="false"><i
                                        className="fa fa-pencil-square-o bg-color-6" aria-hidden="true"/>
                                        <span>Student Registration</span></Link>
                                </li>  */}                             
                                <li className=" dropdown color-8 active">
                                    <a href="https://www.mealmanage.com" onClick={this.signOut.bind(this)} role="button" aria-haspopup="true"
                                          aria-expanded="false"><i
                                        className="fa fa-sign-out bg-color-4" aria-hidden="true"/>
                                        <span>Sign out</span></a>
                                </li>
                                
                                
                            </ul>
                        </div>
                    </div>
                </nav>
            </header>

        )
    }
}

export default parentHeader;


// WEBPACK FOOTER //
// ./src/components/Parent/Home/parentHeader.js